// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.week-picker-display {
  height: 40px;
  width: 300px;
  color: #454545;
  position: relative;
  border-radius: 8px;
  cursor: pointer;
  background: #fafafb;
  justify-content: space-between;
  border: 1px solid #E0E0E0;
  transition: 0.5s ease;
  padding: 0 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.875rem; 
}

.week-picker-options {
  padding: 0.4rem;
  position: absolute;
  top: 105%;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  border-radius: 5px;
  border: 1px solid #E0E0E0;
  overflow: hidden;
  background: white;
  z-index: 99;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title-week {
  padding: 0.8rem;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.numbers-container {
  border-top: 1px solid gainsboro;
  width: 100%;
  padding: 0.3rem;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
}

.single-number {
  width: 100%;
  aspect-ratio: 1;
  font-size: 0.8rem;
  background: none;
  color: black;
  display: grid;
  place-items: center;
}

.selected-week {
  color: black;
  background-color: #f1f5f9;
}

.other-month {
  background: none;
  color: #c3c0cc;
}

.day {
  background: none;
  color: black;
}

.arrow-container {
  cursor: pointer;
  width: 25px;
  height: 25px;
  transition: 0.2s ease-in;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.arrow-container svg {
  stroke: #454545;
}

.arrow-container:hover {
  background-color: #ff9900;
  border-radius: 15%;
}

.arrow-container:hover svg {
  stroke: #fff;
  fill: #fff;
}

.other-month {
  background: none;
  color: #c3c0cc;
}
`, "",{"version":3,"sources":["webpack://./src/components/week-picker/week-picker.style.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EAGnB,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EAEzB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".week-picker-display {\n  height: 40px;\n  width: 300px;\n  color: #454545;\n  position: relative;\n  border-radius: 8px;\n  cursor: pointer;\n  background: #fafafb;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #E0E0E0;\n  transition: 0.5s ease;\n  padding: 0 1rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 0.875rem; \n}\n\n.week-picker-options {\n  padding: 0.4rem;\n  position: absolute;\n  top: 105%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 100%;\n  border-radius: 5px;\n  border: 1px solid #E0E0E0;\n  display: flex;\n  overflow: hidden;\n  background: white;\n  z-index: 99;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.title-week {\n  padding: 0.8rem;\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.numbers-container {\n  border-top: 1px solid gainsboro;\n  width: 100%;\n  padding: 0.3rem;\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;\n}\n\n.single-number {\n  width: 100%;\n  aspect-ratio: 1;\n  font-size: 0.8rem;\n  background: none;\n  color: black;\n  display: grid;\n  place-items: center;\n}\n\n.selected-week {\n  color: black;\n  background-color: #f1f5f9;\n}\n\n.other-month {\n  background: none;\n  color: #c3c0cc;\n}\n\n.day {\n  background: none;\n  color: black;\n}\n\n.arrow-container {\n  cursor: pointer;\n  width: 25px;\n  height: 25px;\n  transition: 0.2s ease-in;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n}\n\n.arrow-container svg {\n  stroke: #454545;\n}\n\n.arrow-container:hover {\n  background-color: #ff9900;\n  border-radius: 15%;\n}\n\n.arrow-container:hover svg {\n  stroke: #fff;\n  fill: #fff;\n}\n\n.other-month {\n  background: none;\n  color: #c3c0cc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
